import { selectProducto, setCantidad } from "@/state/server";
import {
  faArrowCircleDown,
  faTimesCircle,
  faArrowCircleUp,
  faPen,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useConfigContext } from "../state/configContext";
import { SelectProducto } from "./SelectProducto";
import type { Foto } from "@/state/types";
import { formatMoney } from "@/helpers/helpers";
import { Link } from "@tanstack/react-router";

export function PedidoIcons({
  foto,
  pedido,
  setActive,
  pref = "",
}: {
  foto: Foto;
  pedido: number;
  setActive: () => unknown;
  pref?: "/admin" | "";
}) {
  const config = useConfigContext();

  const bajarIconParams =
    foto.cantidad! > 1
      ? {
          icon: faArrowCircleDown,
          style: { fontSize: "120%", color: "#428bca" },
        }
      : {
          icon: faTimesCircle,
          style: { fontSize: "120%", color: "#f00" },
        };

  return (
    <div className="icons">
      <div className="producto">
        <SelectProducto
          temporada={foto.t!}
          onSelect={(p) => {
            setActive();
            selectProducto(pedido, foto.i, p, pref);
          }}
          value={foto.producto!}
        />
      </div>
      <div>
        <div className="cantidad" style={{ fontSize: "200%" }}>
          <FontAwesomeIcon
            {...bajarIconParams}
            onClick={() => {
              setActive();
              setCantidad(pedido, foto.i, foto.cantidad! - 1, pref);
            }}
          />
          &nbsp;
          <span className="valor">{foto.cantidad}</span>
          &nbsp;
          <FontAwesomeIcon
            icon={faArrowCircleUp}
            style={{ fontSize: "120%", color: "#428bca" }}
            onClick={() => {
              setActive();
              setCantidad(pedido, foto.i, foto.cantidad! + 1, pref);
            }}
          />
          <Link
            to={`${pref}/editor`}
            search={{ pedido_id: pedido, foto_id: foto.i }}
          >
            {" "}
            <FontAwesomeIcon icon={faPen} style={{ fontSize: "80%" }} />
          </Link>
        </div>
        <div className="precio">
          <span className="valor">
            {foto.descuento ? (
              <span style={{ textDecoration: "line-through", fontSize: "75%" }}>
                {formatMoney(foto.precio || 0)}
              </span>
            ) : null}
            &nbsp;
            {
              // TODO: foto.precio no deberia ser opcional
              `${formatMoney((foto.precio || 0) - (foto.descuento || 0))} ${config.moneda}`
            }
            {foto.promo ? (
              <span>
                <br />
                <span>{`PROMO ${foto.promo}`}</span>
              </span>
            ) : null}{" "}
          </span>
        </div>
      </div>
    </div>
  );
}
